const galleries = document.querySelectorAll(".js--overflow-gallery");

galleries.forEach(elem => {

  const sliderWrapper = elem.querySelector('.js--slide-wrapper');
  const prevButton = elem.querySelector('[aria-label="prev"]');
  const nextButton = elem.querySelector('[aria-label="next"]');
  const scrollWrapper = elem.querySelector('.js--scroll-wrapper');
  const scrollThumb = elem.querySelector('.js--scroll-thumb');
  if (!sliderWrapper) return;

  updateScrollbar({ sliderWrapper, scrollWrapper, scrollThumb, prevButton, nextButton });

  // Click events using optional chaining
  prevButton?.addEventListener('click', () => slide(sliderWrapper, 'prev'));
  nextButton?.addEventListener('click', () => slide(sliderWrapper, 'next'));

  // Passive scroll listener for excellent mobile/trackpad performance
  sliderWrapper.addEventListener('scroll', () => {
    updateScrollbar({ sliderWrapper, scrollWrapper, scrollThumb, prevButton, nextButton });
  }, { passive: true });

  // Native Accessibility Keyboard controls
  sliderWrapper.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') slide(sliderWrapper, 'prev');
    if (e.key === 'ArrowRight') slide(sliderWrapper, 'next');
  });

  // Global window resize fallback - simple, classic, direct
  window.addEventListener('resize', () => {
    updateScrollbar(sliderWrapper, scrollWrapper, scrollThumb, prevButton, nextButton);
  });
});



function updateScrollbar({ sliderWrapper, scrollWrapper, scrollThumb, prevButton, nextButton } = {}) {
  if (!sliderWrapper || !scrollThumb) return;
  const scrollLeft = sliderWrapper.scrollLeft;
  const scrollWidth = sliderWrapper.scrollWidth;
  const clientWidth = sliderWrapper.clientWidth;
  const maxScrollLeft = scrollWidth - clientWidth;

  if (maxScrollLeft <= 0) {
    if (scrollWrapper) scrollWrapper.ariaHidden = 'true';
    scrollThumb.style.width = '0%';
    if (prevButton) prevButton.disabled = true;
    if (nextButton) nextButton.disabled = true;
    return;
  }

  if (scrollWrapper) scrollWrapper.ariaHidden = 'false';

  // Calculate layout percentages
  const scrollPercentage = scrollLeft / maxScrollLeft;
  const thumbWidthPercentage = (clientWidth / scrollWidth) * 100;
  const thumbLeftPercentage = scrollPercentage * (100 - thumbWidthPercentage);

  // Apply visual updates
  scrollThumb.style.width = `${thumbWidthPercentage}%`;
  scrollThumb.style.left = `${thumbLeftPercentage}%`;

  // Update button states (with 1px rounding tolerance)
  if (prevButton) prevButton.disabled = scrollLeft <= 0;
  if (nextButton) nextButton.disabled = (scrollLeft + clientWidth) >= (scrollWidth - 1);
}

/**
 * Handles the smooth scrolling animation based on direction.
 */
function slide(sliderWrapper, direction) {
  if (!sliderWrapper || !sliderWrapper.firstElementChild) return;

  // Calculate layout distances instantly on click
  const itemWidth = sliderWrapper.firstElementChild.offsetWidth;
  const gap = parseFloat(window.getComputedStyle(sliderWrapper).gap) || 0;
  const scrollDistance = itemWidth + gap;

  sliderWrapper.scrollBy({
    left: direction === 'next' ? scrollDistance : -scrollDistance,
    behavior: 'smooth'
  });
}